// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
// This import has been flagged as unallowed for this class. It may be involved in a circular dependency loop.
// eslint-disable-next-line no-restricted-imports
import { CollectionService } from "@box/admin-console/common";
import { safeProvider, SafeProvider } from "@box/angular/platform/utils/safe-provider";
import { ApiService } from "@box/common/abstractions/api.service";
import { PolicyService } from "@box/common/admin-console/abstractions/policy/policy.service.abstraction";
import { AccountService } from "@box/common/auth/abstractions/account.service";
import { KeyGenerationService } from "@box/common/key-management/crypto";
import { EncryptService } from "@box/common/key-management/crypto/abstractions/encrypt.service";
import { ConfigService } from "@box/common/platform/abstractions/config/config.service";
import { I18nService } from "@box/common/platform/abstractions/i18n.service";
import { LogService } from "@box/common/platform/abstractions/log.service";
import { PlatformUtilsService } from "@box/common/platform/abstractions/platform-utils.service";
import { KeyServiceLegacyEncryptorProvider } from "@box/common/tools/cryptography/key-service-legacy-encryptor-provider";
import { LegacyEncryptorProvider } from "@box/common/tools/cryptography/legacy-encryptor-provider";
import { ExtensionRegistry } from "@box/common/tools/extension/extension-registry.abstraction";
import { buildExtensionRegistry } from "@box/common/tools/extension/factory";
import {
  createSystemServiceProvider,
  SystemServiceProvider,
} from "@box/common/tools/providers";
import { CipherService } from "@box/common/vault/abstractions/cipher.service";
import { FolderService } from "@box/common/vault/abstractions/folder/folder.service.abstraction";
import { RestrictedItemTypesService } from "@box/common/vault/services/restricted-item-types.service";
import { KeyService } from "@box/key-management";
import { StateProvider } from "@box/state";
import { SafeInjectionToken } from "@box/ui-common";

import {
  ImportApiService,
  ImportApiServiceAbstraction,
  ImportService,
  ImportServiceAbstraction,
} from "../services";

// FIXME: unify with `SYSTEM_SERVICE_PROVIDER` when migrating it from the generator component module
//        to a general module.
export const SYSTEM_SERVICE_PROVIDER = new SafeInjectionToken<SystemServiceProvider>(
  "SystemServices",
);

/** Import service factories */
export const ImporterProviders: SafeProvider[] = [
  safeProvider({
    provide: ImportApiServiceAbstraction,
    useClass: ImportApiService,
    deps: [ApiService],
  }),
  safeProvider({
    provide: LegacyEncryptorProvider,
    useClass: KeyServiceLegacyEncryptorProvider,
    deps: [EncryptService, KeyService],
  }),
  safeProvider({
    provide: ExtensionRegistry,
    useFactory: () => {
      return buildExtensionRegistry();
    },
    deps: [],
  }),
  safeProvider({
    provide: SYSTEM_SERVICE_PROVIDER,
    useFactory: createSystemServiceProvider,
    deps: [
      LegacyEncryptorProvider,
      StateProvider,
      PolicyService,
      ExtensionRegistry,
      LogService,
      PlatformUtilsService,
      ConfigService,
    ],
  }),
  safeProvider({
    provide: ImportServiceAbstraction,
    useClass: ImportService,
    deps: [
      CipherService,
      FolderService,
      ImportApiServiceAbstraction,
      I18nService,
      CollectionService,
      KeyService,
      EncryptService,
      KeyGenerationService,
      AccountService,
      RestrictedItemTypesService,
    ],
  }),
];
